export enum CidadeUsuarioStatus {
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO'
}
